import api from '@/api'
import contacts from '@/api/apiSferest/services/contacts'

/**
 * Map contact data into expected structure
 * @param {*} id            Contact unique identifier
 * @param {*} type          Contact type
 * @param {*} source        Contact source
 * @param {*} name          Contact name
 * @param {*} tradeName     Contact trade name
 * @param {*} lastName      Contact last name
 * @param {*} document      Contact document
 * @param {*} contactMedium Contact medium
 * @return {Object} Expected structure
 */
const mapContactData = ({ id, type, source, name, tradeName, lastName, document, contactMedium }) => {
  let dpt = contactMedium ? contactMedium.department : null
  tradeName = source === 'promoter' && !!dpt
                ? dpt
                : type === 'NP' && !!lastName
                  ? `${tradeName} ${lastName}`
                  : tradeName
  return {
    id,
    source,
    document,
    name,
    tradeName
  }
}

export const getList = ({ commit, state, getters, dispatch }) => {
  dispatch('loading')
  return new Promise((resolve, reject) => {
    let params = {
      ...getters['query'],
      sort: state.search.sort || 'name',
      limit: state.search.limit
    }
    contacts.list(params)
    .then((res) => {
      commit('list/SET_LIST', res.data.map(contact => mapContactData(contact)))
      commit('search/SET_MORE', res.headers['x-next-page'])
      dispatch('loaded')
      resolve(res.data)
    })
  })
}

export const getMore = ({ commit, state }) => {
  return new Promise((resolve, reject) => {
    api.apiSferest.get(state.search.more, { data: {} })
    .then((res) => {
      if (res.data && typeof res.data === 'object' && !Array.isArray(res.data)) {
        reject(new Error('Error de conexión'))
        return
      }
      commit('list/ADD_TO_LIST', res.data.map(contact => mapContactData(contact)))
      commit('search/SET_MORE', res.headers['x-next-page'])
      resolve(res.data)
    })
  })
}

export const resetParams = ({ commit }) => {
  return new Promise((resolve, reject) => {
    commit('SET_TRADENAME', '')
    commit('SET_NAME', '')
    commit('SET_DOCUMENT', '')
    commit('search/SET_MORE', undefined)
    commit('search/SET_LIMIT', 10)
    commit('search/SET_SORT', undefined)
    resolve()
  })
}

/**
 * Remove contact
 * @param {Array} selected - List of contacts
 */
export const remove = ({ commit, dispatch }, selected) => {
  return new Promise((resolve, reject) => {
    dispatch('errors/empty', {}, { root: true }).then(() => {
      contacts.remove('personal',
        selected.filter(x => x.source !== 'promoter').map(x => x.id)
      ).then((res) => {
        resolve(res)
      })
    })
  })
}

export const loading = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', false)
    resolve(false)
  })
}

export const loaded = ({ commit }) => {
  return new Promise((resolve) => {
    commit('SET_LOADED', true)
    resolve(true)
  })
}
